import React from 'react';
import { withFormsy } from 'formsy-react';

import FieldError from './../FieldError'
import ReactHtmlParser from 'react-html-parser';
import withBaseFormsy from './withBaseFormsy'

class Table extends withBaseFormsy(React.Component) {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);

  }

  changeValue(event) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    this.setValue(event)
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();

    const item = this.props.item || {}

    const rows = item.format.table.rows
    const cols = item.format.table.columns

    let opts = {}

    // if (item.is_optional)
    //   opts = {
    //     validations: "minLength:1",
    //     validationError: "This field is required",
    //     require: true
    //   }

    return (
      <div className={this.props.className}>
        <label htmlFor={`${item.id}_0`} className="col-md-12" style={{padding: 0}}>
          {item.name}{this.props.required ? <span className="label-require">(必須)</span> : ""} <br/>
          {ReactHtmlParser(item.note)}
        </label>
        <table>
          <thead>
            <tr>
              <th></th>
              {cols.map(col => <th key={col}>{col}</th>)}
            </tr>
          </thead>
          <tbody>
          {rows.map((row, i) => <tr key={row}>
            <td>{row}</td>
            {cols.map((col, j) => {
              return <td key={col}>
                <input
                  onChange={this.changeValue}
                  onClick={this.props.onClick}
                  placeholder={this.props.placeholder}
                  // name={`${this.props.name}[${row}]`}
                  data-row={i}
                  data-col={j}
                  className={`form-control ${errorMessage ? "has-error" : ""}`}
                  {...opts}
                />
              </td>
            })}
          </tr>)}
          </tbody>
        </table>
        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(Table);
